const routes = [
    {
        path: "/proficiency/exam/scores/",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "proficiencyexam_index"
        }
    }
];

export default routes;
